/**
 * @function getPath
 * @desc Deprecated please use JavaScript's native optional chaining feature instead.  getPath Gets
 * the value at path of object. If the resolved value is undefined then the defaultValue is returned
 * in its place.
 * @param {object} obj - object to traverse
 * @param {string} path - dot-delimited string of steps to take in order to traverse the object
 * @param {string} retval - a value to return if the path could not be found. It defaults to undefined
 * @returns {any} value specified by the path or default value
 * @deprecated use optional chaining instead
 */
export default (
  obj: object | null | undefined,
  path: string,
  retval: number | string | boolean | undefined = undefined
): string | number | boolean | object | any[] | undefined => {
  if (obj == null || obj === undefined) {
    return retval;
  }

  const desugaredPath = path.replace(/\[(.)\]/g, '.$1');
  const splitPath = desugaredPath.split('.');

  const traverse = (
    acc: Array<string | number | boolean> | object | any,
    val: number | string | any
  ): any => {
    if (acc === undefined || acc === null || acc[val] === undefined) {
      return retval;
    }
    return acc[val];
  };

  return splitPath.reduce(traverse, obj);
};
